import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  image = "https://sweet-clean.com.ua/logo512.png",
  url = "https://sweet-clean.com.ua",
}) {
  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />

      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
}